import React, { useState } from 'react'
import FormSettingSelect from './FormSettingSelect';
import { SearchIcon } from '@mui/icons-material/Search';
import { appointmentStatus, dateStatus, emialStatus, fillintheBlankStatus, fullNameStatus, inputStatus, numberStatus, productListStatus, timeStatus } from '../Constant/PassOptionSetting';

const PassOption = ({ selectedOption , name , onSelectChange , placeholder , search , multi }) => {


    const handlePassOption = () => {
        switch (selectedOption) {
            case 'نام و نام خانوادگی':
                return fullNameStatus;
            case 'ایمیل':
                return emialStatus;
            case 'آدرس':
                return emialStatus;
            case 'تلفن':
                return fullNameStatus;
            case 'تقویم':
                return dateStatus;
            case 'وقت ملاقات':
                return appointmentStatus;
            case 'امضا':
                return fullNameStatus;
            case 'جای خالی را پر کنید':
                return fillintheBlankStatus;
            case 'لیست محصولات':
                return productListStatus;
            case 'متن کوتاه':
                return fillintheBlankStatus;
            case 'متن طولانی':
                return fillintheBlankStatus;
            case 'بازشونده':
                return productListStatus;
            case 'تک گزینه ای':
                return productListStatus;
            case 'چند گزینه ای':
                return productListStatus;
            case 'شماره':
                return numberStatus;
            case 'آپلود فایل':
                return fullNameStatus;
            case 'زمان':
                return timeStatus;
            case 'شمارنده':
                return numberStatus;
            case "جدول ورودی":
                return inputStatus;
            case "رتبه بندی ستاره ای":
                return timeStatus;
            case "رتبه بندی مقیاس":
                return timeStatus;
            default:
                return []
        }
    }


    return (
        <FormSettingSelect options={handlePassOption()} id={0} name={name} onSelectChange={onSelectChange} placeholder={placeholder} multi={multi} search={search}/>
    )
}

export default PassOption